
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from "moment";

export const WTPQuantityOfWaterExportData = (props) => {
    const { ExcelData, name, searchName } = props

    console.log('ExcelData',ExcelData)
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />
            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '48%' }}>

                <h5><span>&emsp;</span></h5>

                <tr>
                    <th colSpan={7} style={{ textAlign: 'center', fontSize: 16, border: '1px solid black' }}>{name}</th>
                </tr>

                {/* <tr><td></td></tr> */}

                <thead className="thead-dark" >
                    <tr style={{ backgroundColor: '#254462', color: "#fff" }}>
                        <th style={{ borderLeft: "1px solid black" }}>Sr.No.</th>
                        <th style={{ borderLeft: "1px solid white" }}>Date</th>
                        <th style={{ borderLeft: "1px solid white" }}>Raw Water Received From Dam</th>
                        <th style={{ borderLeft: "1px solid white" }}>Raw Water Supplied To MJP</th>
                        <th style={{ borderLeft: "1px solid white" }}>Net Raw Water Supplied To NMMC</th>
                        <th style={{ borderLeft: "1px solid white" }}>Treatment Loss in MLD</th>
                        <th style={{ borderLeft: "1px solid white" }}>Quantity of Pure Water Pump From Pure Water Sump</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((i) => (
                            <tr style={{ textAlign: "center", border: '1px solid black' }}>
                                <td>{i?.rowNum}</td>
                                <td>{i?.readingDate ? moment(i?.readingDate).format('DD-MM-YYYY') : '-'}</td>
                                <td>{i?.rawWaterReceivedFromDam ? i?.rawWaterReceivedFromDam.toFixed(2) : 0}</td>
                                <td>{i?.rawWaterSuppliedToMJP ? i?.rawWaterSuppliedToMJP.toFixed(2) : 0}</td>
                                <td>{i?.netRawWaterSuppliedToNMMC ? i?.netRawWaterSuppliedToNMMC.toFixed(2) : 0}</td>
                                <td>{i?.treatmentLossInMLD ? i?.treatmentLossInMLD.toFixed(2) : 0}</td>
                                <td>{i?.quantityofPureWater ? i?.quantityofPureWater.toFixed(2) : 0}</td>

                            </tr>
                        )) : <tr>No data</tr>
                    }
                </tbody>
            </table>
        </div>
    )
}